import {createRouter, createWebHistory} from 'vue-router';
import i18n from "@/i18n";
import store from "@/store";

const DashboardView = () => import('@/views/DashboardView.vue');
const KassaView = () => import('@/views/KassaView.vue');
const ClientsAndDiscountsView = () => import("@/views/ClientsAndDiscountsView.vue");
const CatalogAndSuppliesView = () => import('@/views/CatalogAndSuppliesView.vue');
const StaffView = () => import('@/views/StaffView.vue');
const PricingView = () => import("@/views/PricingView.vue");
const PersonalAccountView = () => import('@/views/PersonalAccountView.vue');
const SignUpView = () => import("@/views/SignUpView.vue");
const SignInView = () => import("@/views/SignInView.vue");
const ChooseRoleView = () => import("@/views/ChooseRoleView.vue");
const AccountConfirmationView = () => import("@/views/AccountConfirmationView.vue");
const CreateCompanyView = () => import("@/views/CreateCompanyView.vue");
const ResetPasswordView = () => import("@/views/ResetPasswordView.vue");
const ResetPhoneView = () => import("@/views/ResetPhoneView.vue");
const ChooseCompanyView = () => import("@/views/ChooseCompanyView.vue");
const ResetEmailContinueView = () => import("@/views/ResetEmailContinueView.vue");
const ResetEmailFinalView = () => import("@/views/ResetEmailFinalView.vue");
const PageNotFoundView = () => import("@/views/PageNotFoundView.vue");
const SignOutView = () => import("@/views/SignOutView.vue");
const StatisticsView = () => import("@/views/StatisticsView.vue");
const SalesSearchView = () => import("@/views/SalesSearchView.vue");
const AIConciergeView = () => import("@/views/AIConciergeView.vue");


const routes = [
  {
    path: '/dashboard/',
    name: 'dashboard',
    component: DashboardView,
    meta: {
      title: "Cash registers",
    },
  },
  {
    path: '/cash-register/',
    name: 'cash-register',
    component: KassaView,
    meta: {
      title: "Cash register",
    },
  },
  {
    path: "/clients/",
    name: "clients",
    component: ClientsAndDiscountsView,
    meta: {
      title: "Clients and discounts",
    },
  },
  {
    path: "/catalog/",
    name: "catalog",
    component: CatalogAndSuppliesView,
    meta: {
      title: "Catalog",
    },
  },
  {
    path: "/staffs/",
    name: "staffs",
    component: StaffView,
    meta: {
      title: "Staff members",
    },
  },
  {
    path: "/schedule-and-salary/",
    name: "schedule-and-salary",
    component: StaffView,
    meta: {
      title: "Schedules and salaries",
    },
  },
  {
    path: "/pricing/",
    name: "pricing",
    component: PricingView,
    meta: {
      title: "Plans",
    },
  },
  {
    path: "/account/",
    name: "account",
    component: PersonalAccountView,
    meta: {
      title: "Personal account",
    },
  },
  {
    path: "/sign-up/",
    name: "sign-up",
    component: SignUpView,
    meta: {
      title: "Account registration",
    }
  },
  {
    path: "",
    name: "sign-in",
    component: SignInView,
    meta: {
      title: "Sign in",
    }
  },
  {
    path: "/sign-out/",
    name: "sign-out",
    component: SignOutView,
    meta: {
      title: "Sign out",
    }
  },
  {
    path: "/role/",
    name: "role",
    component: ChooseRoleView,
    meta: {
      title: "Role selection",
    }
  },
  {
    path: "/confirm/",
    name: "account-confirmation",
    component: AccountConfirmationView,
    meta: {
      title: "Account confirmation",
    }
  },
  {
    path: "/reset-password/",
    name: "reset-password",
    component: ResetPasswordView,
    meta: {
      title: "Password reset",
    }
  },
  {
    path: "/reset-phone/",
    name: "reset-phone",
    component: ResetPhoneView,
    meta: {
      title: "Phone number update",
    }
  },
  {
    path: "/reset-email/",
    name: "reset-email-continue",
    component: ResetEmailContinueView,
    meta: {
      title: "Email update",
    }
  },
  {
    path: "/reset-email/final/",
    name: "reset-email-final",
    component: ResetEmailFinalView,
    meta: {
      title: "Email update confirmation",
    }
  },
  {
    path: "/create-company/",
    name: "create-company",
    component: CreateCompanyView,
    meta: {
      title: "Create a company",
    }
  },
  {
    path: "/choose-company/",
    name: "choose-company",
    component: ChooseCompanyView,
    meta: {
      title: "Company selection",
    }
  },
  {
    path: '/statistics/',
    name: 'statistics',
    component: StatisticsView,
    meta: {
      title: "Statistics",
    },
  },
  {
    path: '/sales-search/',
    name: 'sales-search',
    component: SalesSearchView,
    meta: {
      title: "Sales search",
    },
  },
  {
    path: '/appointments/',
    name: 'appointments',
    component: () => import('@/views/AppointmentsView.vue'),
    meta: {
      title: "Appointments",
    },
  },
  {
    path: '/ai-concierge/',
    name: 'ai-concierge',
    component: AIConciergeView,
    meta: {
      title: "AI concierge",
    },
  },
  {
    path: '/booking/:token/cancel/:cancelToken',
    name: 'public-booking-cancel',
    component: () => import('@/views/PublicBookingCancelView.vue'),
    meta: { title: "Cancel Booking", public: true },
  },
  {
    path: '/booking/:token/confirm/:confirmToken',
    name: 'public-booking-confirm',
    component: () => import('@/views/PublicBookingConfirmView.vue'),
    meta: { title: "Confirm Booking", public: true },
  },
  {
    path: '/booking/:token/:shopId?',
    name: 'public-booking',
    component: () => import('@/views/PublicBookingView.vue'),
    meta: { title: "Online Booking", public: true },
  },
  {
    path: '/:catchAll(.*)',
    name: "page-not-found",
    component: PageNotFoundView,
    meta: {
      title: "Page Not Found",
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export const PUBLIC_ROUTES = [
  'sign-in', 'sign-up', 'account-confirmation', 'reset-password',
  'reset-phone', 'reset-email-continue', 'reset-email-final', 'page-not-found',
  'public-booking', 'public-booking-cancel', 'public-booking-confirm',
];

export const CONTEXT_FREE_ROUTES = [
  ...PUBLIC_ROUTES,
  'role', 'choose-company', 'create-company', 'sign-out',
];

router.beforeEach((to, from, next) => {
  document.title = i18n.global.t(to.meta.title || 'Intilly');

  const isAuthorized = store.state.authentication.isAuthorized;
  if (!isAuthorized && !PUBLIC_ROUTES.includes(to.name)) {
    next({name: 'sign-in'});
    return;
  }

  if (store.state.authentication.appInitialized && !CONTEXT_FREE_ROUTES.includes(to.name)) {
    const role = store.state.personalData.role;
    const companyToken = store.state.company.companyData?.token;
    if (!role || !companyToken) {
      next({name: 'role'});
      return;
    }
  }

  next();
});

export default router
